import React from 'react';
import { AppProvider } from './context/AppContext';
import ErrorWrapper from './components/ErrorWrapper';
import { EventSection } from './components/EventSection';

function App({ list, count }) {
  return (
    <>
      <AppProvider>
        <ErrorWrapper>
          <EventSection
            list={list}
            count={count}
            isShort={!isNaN(parseFloat(count)) && isFinite(count)}
          />
        </ErrorWrapper>
      </AppProvider>
    </>
  );
}

export default App;
